import * as React from "react";
import { useNavigate } from "react-router-dom";
import { NewModal } from "../uiMerge/newModal";
import NewButton from "../uiMerge/newButton";
import emailIcon from "../../assets/images/email-icon.svg";
import * as ROUTES from "../../constants/routes";

interface ForgotPasswordResetModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
}

export const ForgotPasswordResetModal: React.FC<ForgotPasswordResetModalProps> = ({
  visible,
  onCancel,
  onOk,
}) => {
  const navigate = useNavigate();

  return (
    <NewModal
      colorClass="bg-black"
      animationClass="grow-in"
      position="end"
      showCloseButton={false}
      isOpen={visible}
      onClose={onCancel}
      onOk={onOk}
    >
      <div className="w-full flex flex-col justify-center items-center py-10 px-[1rem]">
        <div className="flex flex-col gap-y-6 justify-center items-center">
          <div>
            <img
              src={emailIcon}
              alt="Reset Successful"
              width={89}
              height={89}
            />
          </div>

          <div className="flex flex-col items-center text-center justify-center ">
            <h2 className="text-2xl text-white "> Email Sent!</h2>
            <p className="w-[85%] text-[#CECECF] text-[16px]">
              If the email you entered exists with us, you'll receive a confirmation link to continue. 
              Please check your inbox.
            </p>
          </div>

          <NewButton
            fullWidth
            variant="primary"
            onClick={() => navigate(ROUTES.LOGIN)}
          >
            Done
          </NewButton>
        </div>
      </div>
    </NewModal>
  );
};